// import { Events } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { AlertController } from '@ionic/angular';
import { ServicioService } from './servicio.service';

// import { UtilitiesService } from './utilities.service';

const CART_KEY = 'cartRDL';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  pais = 'co';

  constructor(
    private storage: Storage,
    private alertCtrl: AlertController,
    private service: ServicioService
    // private utilities: UtilitiesService,
    // private events: Events
  ) {

    this.service.getVariable('pais').then((val) => {
      this.pais = val;
    });

  }

  // ************************************************* CARRO ***********************************************************

  async addToCart(product) {

    await this.service.getVariable('pais').then((val) => {
      this.pais = val;
    });

    return this.getCartItems().then(async result => {
      if (result) {

        const index = result.findIndex(x => x.product_id + x.tipo === product.product_id + product.tipo);

        // if (!this.containsObject(product, result)) {
        if (index === -1) {

          const prevQuantity = 0;


          // Validar inventario y regresar si el valor es igual Solo para express y estandar
          if (product.tipo !== '0') {
            if (product.inventario < (Number(prevQuantity) + Number(product.count))) {

              let type = '';
              if (product.tipo === 'estandar') {
                type = 'estándar';
              } else if (product.tipo === 'fisico') {
                type = 'físico';
              } else {
                type = 'express';
              }

              return 'error';
            }
          }

          await this.service.publishCartData({
            ev: 'add'
          });

          result.push(product);
          return this.storage.set(CART_KEY + this.pais, result);


        } else {

          // const index = result.findIndex(x => x.product_id + x.tipo === product.product_id + product.tipo);
          const prevQuantity = Number(result[index].count);


          // Validar inventario y regresar si el valor es igual Solo para express y estandar
          if (product.tipo !== '0') {
            if (product.inventario < (Number(prevQuantity) + Number(product.count))) {

              let type = '';
              if (product.tipo === 'estandar') {
                type = 'estándar';
              } else if (product.tipo === 'fisico') {
                type = 'físico';
              } else {
                type = 'express';
              }

              //   this.utilities.showAlert('Error', 'No hay mas inventario ' + type + ' para el producto: ' + product.reference + ' ' + product.color + ' ' + product.presentationSize + ' !');
              return 'error';
            }
          }

          product.count = (Number(prevQuantity) + Number(product.count));
          const currentPrice = (Number(product.offerPrice) === 0 ? Number(product.retailPrice) : Number(product.offerPrice)) * Number(product.count);
          product.totalPrice = Number(currentPrice);
          await result.splice(index, 1);

          await this.service.publishCartData({
            ev: 'add'
          });

          await result.push(product);
          //   this.events.publish('lectura');
          return await this.storage.set(CART_KEY + this.pais, result);
        }

      } else {
        return await this.storage.set(CART_KEY + this.pais, [product]);
      }
    });
  }

  async updateCart(product) {

    await this.service.getVariable('pais').then((val) => {
      this.pais = val;
    });

    return this.getCartItems().then(async result => {
      if (result) {
        const index = result.findIndex(x => x.product_id + x.tipo === product.product_id + product.tipo);
        if (this.containsObject(product, result)) {
          
          await this.service.publishCartData({
            ev: 'update'
          });

          await result.splice(index, 1, product);

          return await this.storage.set(CART_KEY + this.pais, result);
        }
      } else {
        return await this.storage.set(CART_KEY + this.pais, [product]);
      }
    });
  }

  async removeFromCart(product) {

    await this.service.getVariable('pais').then((val) => {
      this.pais = val;
    });

    return this.getCartItems().then(async result => {
      if (result) {
        const index = result.findIndex(x => x.id === product);

        await this.service.publishCartData({
          ev: 'remove'
        });

        await result.splice(index, 1);
        return await this.storage.set(CART_KEY + this.pais, result);
      }
    });
  }

  async removeAllCartItems() {
    
    await this.service.publishCartData({
      ev: 'removeAll'
    });

    return this.storage.remove(CART_KEY + this.pais).then(res => {
      return res;
    });
  }

  // replaceCart(items: any) {
  //   return this.storage.set(CART_KEY + this.pais, items);
  // }

  containsObject(obj, list): boolean {
    if (!list.length) {
      return false;
    }

    if (obj == null) {
      return false;
    }
    for (let i = 0; i < list.length; i++) {
      if (list[i].product_id === obj.product_id) {
        return true;
      }
    }
    return false;
  }

  async getCartItems() {

    await this.service.getVariable('pais').then((val) => {
      this.pais = val;
    });

    // await this.service.publishCartData({
    //   ev: 'add'
    // });

    return this.storage.get(CART_KEY + this.pais).then(result => {
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }

  async getCountItems() {

    await this.service.getVariable('pais').then((val) => {
      this.pais = val;
    });

    return this.getCartItems().then(result => {
      if (result) {
        if (!result.length) {
          return 0;
        }
        let cant = 0;
        for (let i = 0; i < result.length; i++) {
          cant = Number(cant) + Number(result[i].count);
        }
        return cant;
      } else {
        return 0;
      }
    });
  }

  getTotal() {
    return this.getCartItems().then(result => {
      if (result) {
        if (!result.length) {
          return 0;
        }
        let cant = 0;
        for (let i = 0; i < result.length; i++) {
          cant = Number(cant) + Number(result[i].totalPrice);
        }
        return cant;
      } else {
        return 0;
      }
    });
  }

  getMaxCartID() {
    return this.getCartItems().then(result => {
      if (result) {
        if (!result.length) {
          return 0;
        }
        let cant = 0;
        for (let i = 0; i < result.length; i++) {
          if (cant < Number(result[i].id)) {
            cant = Number(result[i].id);
          }
        }
        return cant;
      } else {
        return 0;
      }
    });

  }


}
